const OperationalSLAActionTypes = {
  LOAD_FILE_IMPORT: 'operationalSLA/load_file_import',
  NEXT_STEP: 'operationalSLA/next_step',
  PREV_STEP: 'operationalSLA/prev_step',
  CANCEL_IMPORT: 'operationalSLA/cancel_import',
  // LOAD_MATCH_LOCATION: 'shipment/load_match_location',
  LOADING: 'operationalSLA/loading',
  UPDATE_DATA_IMPORT: 'operationalSLA/update_data_import',
};

export default OperationalSLAActionTypes;